var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"more-knowedge"},[_c('common-bg-plate',[_c('change-chain'),_c('div',{staticClass:"user-content"},[_c('bulletproofs',{ref:"bulletproofs"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }